import { twMerge } from "tailwind-merge";

type Size = "sm" | "md" | "lg";

export function getInputFieldClasses(
  size: Size = "md",
  hasError: boolean = false
) {
  const PADDING: Record<Size, string> = {
    sm: "px-2.5",
    md: "px-3",
    lg: "px-3.5",
  };

  const HEIGHT: Record<Size, string> = { sm: "h-8", md: "h-10", lg: "h-12" };

  return twMerge(
    "relative flex w-full items-center rounded-md duration-150",
    "outline-none border",
    hasError
      ? "border-accent_three-600"
      : "border-secondary-100 hover:border-secondary-200 focus:border-primary-500",
    PADDING[size],
    HEIGHT[size]
  );
}
